
    // Event delegation for 'Add to Cart' buttons
    const plpContainers = document.querySelectorAll(".collection__inner");
    plpContainers.forEach((container) => {
    container.addEventListener("click", async (event) => {
        const addToCartButton = event.target.closest(".product-item__quick-add-blacksmith");
        const addQuantityButton = event.target.closest("[data-add-quantity-blacksmith]");
        const removeItemButton = event.target.closest("[data-remove-item-blacksmith]");
        const subtractQuantityButton = event.target.closest("[data-subtract-quantity-blacksmith]");

          if (addToCartButton) {  
            await handleAddToCart(addToCartButton, event);
        } else if (addQuantityButton) {         
            await handleAddQuantity(addQuantityButton, event);
        } else if (removeItemButton) {
            await handleRemoveItem(removeItemButton, event);
        } else if (subtractQuantityButton) {
            await handleSubtractQuantity(subtractQuantityButton, event);
        }
    
      });
    });
  
    /**
 * logic add to cart.
 * @param {HTMLElement} button 
 */
async function handleAddToCart(button, event) {
  event.preventDefault();

  const variantId = button.getAttribute("data-variant-id");
  const variantWrapper = button.closest(".product-item");

  if (!variantId) {
      return;
  }

  try {
      button.disabled = true;

      const payload = {
          id: variantId,
          quantity: 1,
      };

      const response = await fetch(`${window.theme.routes.cart.add}.js`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
          },
          body: JSON.stringify(payload),
      });

      if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
      }

      const cartData = await response.json();

      const quantityInCart = cartData.quantity || 0;


      window.emit("quick-cart:updated");
      window.emit("quick-cart:open");
      window.emit("cart:updated");

  } catch (error) {
      console.error("Error:", error);
  } finally {
      button.disabled = false;
  }
}

/**
 * increase quantity.
 * @param {HTMLElement} button
 */
async function handleAddQuantity(button, event) {
  event.preventDefault();

  const variantId = button.getAttribute("quantity-data-variant-id");
  const variantWrapper = button.closest(".product-item");

  if (!variantId) {
      return;
  }

  try {
      const quantityInput = button.closest(".product-item__quick-add-wrapper").querySelector(".quantity-input");
        if (quantityInput) {
            quantityInput.classList.add('pending-quantity-update');
        }

      const cartData = await getCartData();
      if (!cartData || !Array.isArray(cartData.items)) {
          throw new Error("Wrong format");
      }

      const cartItem = cartData.items.find(item => item.variant_id === parseInt(variantId, 10));
      if (!cartItem) {
          throw new Error("Item not found.");
      }

      const newQuantity = cartItem.quantity + 1;

      const payload = {
          id: cartItem.key,
          quantity: newQuantity,
      };

      const response = await fetch(`${window.theme.routes.cart.change}.js`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
          },
          body: JSON.stringify(payload),
      });

      if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
      }

      const updatedCartData = await response.json();


      window.emit("quick-cart:updated");
      window.emit("cart:updated");

  } catch (error) {
      console.error("Error:", error);
  } finally {
    const quantityInput = button.closest(".product-item").querySelector(".quantity-input");
    if (quantityInput) {
        quantityInput.classList.remove('pending-quantity-update');
    }
  }
}

/**
 * Reduce quantity logic.
 * @param {HTMLElement} button 
 * @param {Event} event 
 */
async function handleSubtractQuantity(button, event) {
  event.preventDefault();

  const variantId = button.getAttribute("quantity-data-variant-id");
  const variantWrapper = button.closest(".product-item");

  if (!variantId) {
      return;
  }

  try {
      const quantityInput = button.closest(".product-item__quick-add-wrapper").querySelector(".quantity-input");
      if (quantityInput) {
          quantityInput.classList.add('pending-quantity-update');
      }

      const cartData = await getCartData();
      if (!cartData || !Array.isArray(cartData.items)) {
          throw new Error("Cart data not available");
      }

      const cartItem = cartData.items.find(item => item.variant_id === parseInt(variantId, 10));
      if (!cartItem) {
          throw new Error("Item not found in the cart");
      }

      const newQuantity = cartItem.quantity - 1;

      if (newQuantity < 1) {
          await handleRemoveItem(button, event);
          return;
      }

      const payload = {
          id: cartItem.key, 
          quantity: newQuantity,
      };

      const response = await fetch(`${window.theme.routes.cart.change}.js`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
          },
          body: JSON.stringify(payload),
      });

      if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
      }

      const updatedCartData = await response.json();


      window.emit("quick-cart:updated");
      window.emit("quick-cart:open");
      window.emit("cart:updated");

  } catch (error) {
      console.error("Error reduce quantity :", error);
  } finally {
      const quantityInput = button.closest(".product-item__quick-add-wrapper").querySelector(".quantity-input");
      if (quantityInput) {
          quantityInput.classList.remove('pending-quantity-update');
      }
  }
}

/**
 * Logic remove variant
 * @param {HTMLElement} button 
 * @param {Event} event 
 */
async function handleRemoveItem(button, event) {
  event.preventDefault();

  const itemKey = button.getAttribute("quantity-data-variant-id");
  const variantWrapper = button.closest(".product-item");

  if (!itemKey) {
      return;
  }

  try {
      const quantityInput = button.closest(".product-item__quick-add-wrapper").querySelector(".quantity-input");
      if (quantityInput) {
          quantityInput.classList.add('pending-quantity-update');
      }

      const payload = {
          id: itemKey,
          quantity: 0, 
      };

      const response = await fetch(`${window.theme.routes.cart.change}.js`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
          },
          body: JSON.stringify(payload),
      });

      if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
      }

      const updatedCartData = await response.json();
      const addToCartText = variantWrapper.querySelector('.product-item__quick-add__add-text-blacksmith');
      const cartCount = variantWrapper.querySelector('.product-item__quick-add__cart-count-blacksmith');
      const cartCountText = variantWrapper.querySelector('.quantity-in-cart-display');
      const cartInput = variantWrapper.querySelector('[data-quantity-input-blacksmith]');
      const cartQuantityActions = variantWrapper.querySelector('.quantity-input-wrapper--product-item-quick-add-blacksmith');
      addToCartText.classList.remove('hidden');
      cartCount.classList.add('hidden');
      cartQuantityActions.classList.add('hidden');
      cartCountText.textContent = 0;
      cartInput.value = 0;
      variantWrapper.classList.remove('variant-in-cart');
      window.emit("quick-cart:updated");
      window.emit("cart:updated");


  } catch (error) {
      console.error("Error:", error);
  } finally {
      const quantityInput = button.closest(".product-item").querySelector(".quantity-input");
      if (quantityInput) {
          quantityInput.classList.remove('pending-quantity-update');
      }

  }
}

function clearCartItemUI(element) {
    if (element) {
        element.classList.remove('variant-in-cart');
        const button = element.querySelector('.product-item__quick-add-blacksmith');
        updateButtonUI(button, 0, element);
    }
}

const headerCartLink = document.querySelector('.header__cart-link');

if (headerCartLink) {
    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList') {
              getCartData()
              .then(cartDataPage => {
                  if (cartDataPage?.items?.length > 0) {
                    
                    const cartItems = cartDataPage.items;
                    const cartVariantIds = [];

                    cartItems.forEach(function (cartItem) {
                        const variantId = cartItem.variant_id;
                        const quantityInCart = cartItem.quantity;
                        cartVariantIds.push(variantId);

                        const variantElement = document.querySelector(`.product-item[data-variant-id='${variantId}']`);
                        if (variantElement){
                            variantElement.setAttribute('data-quantity-in-cart-blacksmith', quantityInCart);
                            const button = variantElement.querySelector('.product-item__quick-add-blacksmith');
                            button.setAttribute('data-quantity-in-cart-blacksmith', quantityInCart);
                            updateButtonUI(button, quantityInCart, variantElement);
                        }
                    });

                    document.querySelectorAll('.product-item.variant-in-cart').forEach((variantInCartElement) => {
                        const variantId = variantInCartElement.getAttribute('data-variant-id');

                        if (!cartVariantIds.includes(Number(variantId))) {
                            clearCartItemUI(variantInCartElement);
                        }
                    });
                }
                else {
                    document.querySelectorAll('.product-item.variant-in-cart').forEach(clearCartItemUI);
                }

                

              });
            }
        });
    });

    const observerOptions = {
        childList: true,
        subtree: false 
    };

    observer.observe(headerCartLink, observerOptions);

}

async function getCartData() {
    return fetch(`${window.theme.routes.cart.base}.js`, {
      method: "GET",
      credentials: "include"
    }).then(function (res) {
      return res.json();
    });
}

function updateButtonUI(button, quantityInCart, wrapper) {
    const addToCartText = wrapper.querySelector('.product-item__quick-add__add-text-blacksmith');
    const cartCount = wrapper.querySelector('.product-item__quick-add__cart-count-blacksmith');
    const cartCountText = wrapper.querySelector('.quantity-in-cart-display');
    const cartInput = wrapper.querySelector('[data-quantity-input-blacksmith]');
    const cartQuantityActions = wrapper.querySelector('.quantity-input-wrapper--product-item-quick-add-blacksmith');
    const subtractQuantityButton = wrapper.querySelector('[data-subtract-quantity-blacksmith]');
    const removeItemButton = wrapper.querySelector('[data-remove-item-blacksmith]');

    if (addToCartText && cartCount) {
      if (quantityInCart > 0) {
        addToCartText.classList.add('hidden');
        cartCount.classList.remove('hidden');
        cartQuantityActions.classList.remove('hidden');
        cartCountText.textContent = quantityInCart;
        wrapper.classList.add('variant-in-cart');
        cartInput.value = quantityInCart;

        if (quantityInCart === 1) {
            subtractQuantityButton.classList.add('hidden');
            removeItemButton.classList.remove('hidden');
        } else {
            subtractQuantityButton.classList.remove('hidden');
            removeItemButton.classList.add('hidden');
        }
      } 
      else {
        addToCartText.classList.remove('hidden');
        cartCount.classList.add('hidden');
        cartQuantityActions.classList.add('hidden');
        wrapper.classList.remove('variant-in-cart');
        cartCountText.textContent = quantityInCart;
        cartInput.value = quantityInCart;
      }
    }
  }

  